import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import FormattedCurrency from '../../../../../components/formatted-currency/container';
import { CurrencyPropType } from '../../../../../prop-types/currency';
import { MessageDescriptorPropType } from '../../../../../prop-types/intl';

import messages, { transactionTypeMessages } from '../../messages';
import { creditTransactionTypes } from '../../constants';
import styles from './styles.module.less';

const ItemBreakdown = ({ transactionTotal, lineItems, transactionType }) => {
  const isCredit = creditTransactionTypes.includes(transactionType);
  const header = isCredit ? <FormattedMessage {...messages.creditBreakdown} /> : <FormattedMessage {...messages.costBreakdown} />;
  const summationLabel = isCredit ? <FormattedMessage {...messages.creditTotal} /> : <FormattedMessage {...messages.costTotal} />;

  return (
    <div className={styles['cost-breakdown']}>
      <h4>{header}</h4>
      {lineItems.map((lineItem, index) => (
        <div key={index} className={styles['line-item']}>
          <div>{typeof lineItem.description === 'string' ? lineItem.description : <FormattedMessage {...lineItem.description} />}</div>
          <div>
            <FormattedCurrency currencyCode={lineItem.amount.code} value={Math.abs(lineItem.amount.value)} />
          </div>
        </div>
      ))}
      <div className={styles.total}>
        <span>{summationLabel}</span>
        <FormattedCurrency currencyCode={transactionTotal.code} value={Math.abs(transactionTotal.value)} />
      </div>
    </div>
  );
};

ItemBreakdown.propTypes = {
  transactionTotal: CurrencyPropType.isRequired,
  lineItems: PropTypes.arrayOf(
    PropTypes.shape({
      amount: CurrencyPropType,
      description: PropTypes.oneOfType([PropTypes.string, MessageDescriptorPropType]),
    }),
  ).isRequired,
  transactionType: PropTypes.oneOf(Object.keys(transactionTypeMessages)).isRequired,
};

export default ItemBreakdown;
